import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./appRoutes/SystemAdmin/Dashboard";
import PrivateRoute from "./common/PrivateRoute";
import Login from "./appRoutes/Login/Login";
import UserMaster from "./appRoutes/SystemAdmin/Users/UserMaster";
import AddUser from "./appRoutes/SystemAdmin/Users/AddUser";
import TaskManager from "./appRoutes/Admin/Task/TaskManagerList";
import AddNewTask from "./appRoutes/Admin/Task/AddTask";
import CompanyMaster from "./appRoutes/SystemAdmin/Company/CompanyMaster";
import AddCompany from "./appRoutes/SystemAdmin/Company/AddCompany";
import BranchList from "./appRoutes/SystemAdmin/Branch/BranchList";
import AddBranch from "./appRoutes/SystemAdmin/Branch/AddBranch";
import PageNotFound from "./common/PageNotFound";

const AppContainer = (props) => {
  const isLoggedIn = !!sessionStorage.getItem("deviceToken");

  const wrapPrivateRoute = (element, user, redirect) => {
    return (
      <PrivateRoute user={user} redirect={redirect}>
        {element}
      </PrivateRoute>
    );
  };

  return (
    <Routes>
      <Route path="/auth/login" element={<Login />} />
      <Route
        path="/"
        element={wrapPrivateRoute(<Dashboard />, isLoggedIn, "profile")}
      />
      <Route
        path="/dashboard"
        element={wrapPrivateRoute(<Dashboard />, isLoggedIn, "profile")}
      />
      <Route
        path="/index"
        element={wrapPrivateRoute(<Dashboard />, isLoggedIn, "profile")}
      />
      {/* User End */}
      <Route
        path="/users"
        element={wrapPrivateRoute(<UserMaster />, isLoggedIn, "profile")}
      />
      <Route
        path="/add-user"
        element={wrapPrivateRoute(<AddUser />, isLoggedIn, "profile")}
      />
      {/* User End */}
      {/* Task Manager */}
      <Route
        path="/task-manager"
        element={wrapPrivateRoute(<TaskManager />, isLoggedIn, "profile")}
      />
      <Route
        path="/add-new-task"
        element={wrapPrivateRoute(<AddNewTask />, isLoggedIn, "profile")}
      />
      {/* Task Manager End */}
      {/* Company Start */}
      <Route
        path="/company"
        element={wrapPrivateRoute(<CompanyMaster />, isLoggedIn, "profile")}
      />
      <Route
        path="/add-company"
        element={wrapPrivateRoute(<AddCompany />, isLoggedIn, "profile")}
      />
      {/* Company End */}
      {/* Branch Start */}
      <Route
        path="/branch"
        element={wrapPrivateRoute(<BranchList />, isLoggedIn, "profile")}
      />
      <Route
        path="/add-branch"
        element={wrapPrivateRoute(<AddBranch />, isLoggedIn, "profile")}
      />
      {/* Branch End */}
      {/* Logout Start */}
      <Route
        path="/logout"
        element={wrapPrivateRoute(<Login />, false, "profile")}
      />
      {/* Logout End */}
      {/* 404 Page */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppContainer;
